import styled from 'styled-components';

export const FreshWaterWrapper = styled.div``;
